// localStorage.loginUserInfo 的字段白名单。SPA 真正读的就这四个：adminIs 做角色门禁、
// id 当 adminId 传给后端、username 发请求、fkStore 定门店。
//
// admin 与跑第三方广告脚本的公开站同源，而 localStorage 是 origin 级、不受 cookie path
// 约束——放进来的每个字段，Ezoic / GTM / Gatekeeper CMP 都能读到。登录接口曾经把整个
// UmsAdmin 塞进来，包括 password 的 BCrypt hash 和 email / mobile。
//
// 加字段前先确认真有消费者，别图省事把整个响应对象存回来。
export const LOGIN_USER_FIELDS = ['id', 'username', 'adminIs', 'fkStore']

export const LOGIN_USER_STORAGE_KEY = 'loginUserInfo'

export function pickLoginUserFields(user) {
  if (!user || typeof user !== 'object') return {}
  return LOGIN_USER_FIELDS.reduce((picked, field) => {
    if (user[field] !== undefined) picked[field] = user[field]
    return picked
  }, {})
}

// 收窄写入只管住下一次登录。部署前登录过的管理员——也就是全部现役管理员——浏览器里
// 那份完整对象原地不动，而 JWT 有 7 天，期间每次访问公开站都还是会被广告脚本读走。
// 所以启动时就地重写一次。
//
// 不用 removeItem：删掉会让 MobileContinuous.vue 的 username 守卫判成「需要重新登录」，
// 把还有效的会话赶去登录页。重写成白名单字段则对所有消费方都是无感的。
export function sanitizeStoredLoginUser() {
  let raw
  try {
    raw = localStorage.getItem(LOGIN_USER_STORAGE_KEY)
  } catch (e) {
    return // 隐私模式下 localStorage 可能直接抛
  }
  if (!raw) return

  let stored
  try {
    stored = JSON.parse(raw)
  } catch (e) {
    return // 坏 JSON 本来就不含凭据，交给 readLoginUser 的既有兜底
  }
  if (!stored || typeof stored !== 'object') return

  const hasExtraneousField = Object.keys(stored).some(key => LOGIN_USER_FIELDS.indexOf(key) === -1)
  if (!hasExtraneousField) return

  try {
    localStorage.setItem(LOGIN_USER_STORAGE_KEY, JSON.stringify(pickLoginUserFields(stored)))
  } catch (e) {
    // 写不进去就算了：这是尽力而为的清理，不该把 app 启动搞挂
  }
}
